import { gql } from '@apollo/client';

export const FETCH_BREAKDOWN_STATIONS = gql`
	query breakdownStations {
		breakdownStations {
			id
			name
			code
			countryCode
			cityId
			longitude
			latitude
			timezone
		}
	}
`;
